import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import CustomInput from "../../Common/CustomInput/CustomInput";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import { addAdmin } from "../../../redux/admin/action";
import Spinner from "../../Layouts/Spinner";
import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import AdminRoles from "./AdminRoles";
import AddUpdateHeader from "../../Common/CardHeader/AddUpdateHeader";
import * as Yup from "yup";

const formData = [
  { title: "First Name", name: "first_name" },
  { title: "Last Name", name: "last_name" },
  { title: "Mobile Number", name: "mobile_number" },
  { title: "Email", name: "email_id" },
  { title: "Password", name: "password" },
  { title: "Status", name: "status" },
  { title: "Admin Roles", name: "roles" },
];

const initialValues = {
  first_name: "",
  last_name: "",
  mobile_number: "",
  email_id: "",
  password: "",
  status: "1",
  // roles: [],
  // permissions: Array.from({ length: 16 }, (_, index) => ({
  //   menu_id: index + 1, // Generates menu_id from 1 to 16
  //   permission_level: [], // Empty array for initial permissions
  // })),
};

const validationSchema = Yup.object({
  first_name: Yup.string()
    .required("This field is required")
    .min(2, "Enter atleast two characters"),
  last_name: Yup.string().required("Last name is required"),
  mobile_number: Yup.string()
    .min(9, "minimum number")
    .max(10, "Maximum of 10 number you can use")
    .required("mobile number is required"),
  email_id: Yup.string()
    .email("enter a Valid mail address")
    .test("email-validation", "enter a Valid mail address", (value) => {
      if (!value) return false;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(value);
    })
    .required("Email is required"),
  password: Yup.string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters"),
});

const Addadmin = ({ data }) => {
  const [loading, setLoading] = useState(false);
  const update = data?.update;
  const dispatch = useDispatch();
  const selectedAdmin = useSelector(({ admin: { editAdmin } }) => editAdmin);
  const navigate = useNavigate();

  useEffect(() => {
    if (update && selectedAdmin?.id) {
      formik.setValues({
        ...initialValues,
        ...selectedAdmin,
      });
    }
  }, [update, selectedAdmin]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: (values) => handleSubmit(values),
    validationSchema: validationSchema,
  });

  const handleContryCode = (value, data) => {
    formik.setFieldValue("mobile_number", value.slice(data.dialCode.length));
    formik.setFieldValue("country_code", `+${data.dialCode}`);
  };

  const handleSubmit = (values) => {
    setLoading(true);
    dispatch(addAdmin(values, setLoading, navigate));
  };

  return (
    <div className=" p-3">
      <div className="category-wrapper">
        <AddUpdateHeader modal={"Create Admin"} list={"Admin List"} />
        <div className="">
          <form onSubmit={formik.handleSubmit}>
            <Row className="">
              {formData.map((prop, key) => {
                if (prop.title === "Mobile Number") {
                  return (
                    <Col className=" " key={key} xs={4}>
                      <div className="form-group">
                        <label htmlFor={prop.name}>{prop.title}</label>
                        <PhoneInput
                          country={"in"}
                          value={
                            formik.values.country_code
                              ? `${formik.values.country_code}${formik.values.mobile_number}`
                              : ""
                          }
                          onChange={(phone, data) =>
                            handleContryCode(phone, data)
                          }
                          onBlur={() =>
                            formik.setFieldTouched("mobile_number", true)
                          }
                        />
                        {formik.touched.mobile_number &&
                        formik.errors.mobile_number ? (
                          <div className="error">
                            {formik.errors.mobile_number}
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  );
                }
                if (prop.name === "status") {
                  const options = [
                    { value: "1", label: "Active" },
                    { value: "2", label: "Inactive" },
                    { value: "4", label: "Block" },
                  ];

                  return (
                    <Col className=" form-group" key={key} xs={4}>
                      <label>{prop.title}</label>
                      <div>
                        <ReactSelect
                          value={options.find(
                            (option) => option.value === formik.values.status
                          )}
                          placeholder={prop.title}
                          id={prop.name}
                          name={prop.name}
                          options={options}
                          onChange={(selectedOption) =>
                            formik.setFieldValue(
                              prop.name,
                              selectedOption.value
                            )
                          }
                          onBlur={() => formik.setFieldTouched(prop.name, true)}
                        />
                        {formik.touched.status && formik.errors.status ? (
                          <div className="error">{formik.errors.status}</div>
                        ) : null}
                      </div>
                    </Col>
                  );
                }
                if (prop.name === "password") {
                  return (
                    <Col className="" key={key} xs={4}>
                      <div className="form-group">
                        <label>Password</label>
                        <CustomInput
                          value={formik.values.password}
                          placeholder={prop.title}
                          id={prop.name}
                          name={prop.name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          touched={formik.touched}
                          errors={formik.errors}
                        />
                      </div>
                    </Col>
                  );
                }
                if (prop.name === "roles") {
                  return (
                    <Col className=" " key={key} xs={12}>
                      <AdminRoles formik={formik} />
                      {formik.touched.roles && formik.errors.roles ? (
                        <div className="error">{formik.errors.roles}</div>
                      ) : null}
                    </Col>
                  );
                }
                return (
                  <Col className="" key={key} xs={4}>
                    <div className="form-group">
                      <label>{prop.title}</label>
                      <CustomInput
                        value={formik.values[prop.name]}
                        placeholder={prop.title}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                      />
                    </div>
                  </Col>
                );
              })}
              <Col
                xs={12}
                className="text-center my-3 d-flex align-items-center justify-content-between"
              >
                <button
                  className="submit-btn"
                  disabled={loading}
                  onClick={() => navigate("/admin")}
                  type="submit"
                >
                  Back
                </button>
                <button className="submit-btn" disabled={loading} type="submit">
                  {!loading ? "Submit" : <Spinner />}
                </button>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Addadmin;
